import Content from "./Content";
import { IWizardStep } from "../../../wizard/types";

export const viewContentConfig: IWizardStep = {
  width: "568px",
  titleConfig: {
    titleText: "View course",
    info: "You can see all the completed steps but you can not edit them.",
  },
  content: Content,
};
